(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blz-announcement"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('blz-announcement'))customElements.define('blz-announcement',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.items=[...this.querySelectorAll('.blz-announcement-messages>a')];this.index=0;this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.events=new AbortController();const o={signal:this.events.signal};this.show=n=>{if(!this.items.length)return;this.index=(n+this.items.length)%this.items.length;this.items.forEach((e,i)=>e.hidden=i!==this.index)};this.schedule=()=>{clearInterval(this.timer);if(this.items.length>1&&!this.motion.matches&&!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.timer=setInterval(()=>this.show(this.index+1),6000)};this.addEventListener('click',e=>{const b=e.target.closest('[data-step]');if(b){this.show(this.index+Number(b.dataset.step));this.schedule()}},o);['mouseenter','mouseleave','focusin'].forEach(e=>this.addEventListener(e,this.schedule,o));this.addEventListener('focusout',()=>setTimeout(this.schedule,0),o);document.addEventListener('visibilitychange',this.schedule,o);this.motion.addEventListener('change',this.schedule,o);this.schedule()}
    disconnectedCallback(){clearInterval(this.timer);this.events?.abort();this.ready=false}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blz-header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-hero-header]');
    const hero = document.querySelector('#MainContent > .shopify-section:first-child .blz-slideshow');
    if (!header || !hero) return;
    const section = header.closest('.shopify-section');
    const update = () => {
      document.documentElement.style.setProperty('--blz-overlay-height', `${header.getBoundingClientRect().height}px`);
      header.toggleAttribute('data-scrolled', window.scrollY > 8);
    };
    update();
    document.body.classList.add('blz-hero-header-ready');
    new ResizeObserver(update).observe(section);
    window.addEventListener('scroll', update, {passive:true});
  })();
  (() => {
    const input = document.querySelector('#blz-search');
    const panel = document.querySelector('.blz-predictive');
    if (!input || !panel) return;
    let timer, controller;
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort();
      if (input.value.trim().length < 2) { panel.hidden = true; return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = new URL(panel.dataset.searchUrl + '.json', location.origin);
          url.searchParams.set('q', input.value); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '5');
          const response = await fetch(url, {signal: controller.signal});
          if (!response.ok) return;
          const data = await response.json(); panel.replaceChildren();
          for (const product of data.resources.results.products) {
            const a = document.createElement('a'); a.href = product.url;
            if (product.image) { const img = document.createElement('img'); img.src = product.image; img.alt = ''; a.append(img); }
            const text = document.createElement('span'); text.textContent = product.title; a.append(text); panel.append(a);
          }
          panel.hidden = !panel.childElementCount;
        } catch (error) { if (error.name !== 'AbortError') panel.hidden = true; }
      }, 180);
    });
    document.addEventListener('click', event => { if (!event.target.closest('.blz-search-wrap')) panel.hidden = true; });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') { panel.hidden = true; document.querySelectorAll('.blz-header details[open]').forEach(el => el.open = false); } });
    document.querySelectorAll('.blz-desktop-nav details').forEach(detail => detail.addEventListener('toggle', () => { if (detail.open) document.querySelectorAll('.blz-desktop-nav details').forEach(other => { if (other !== detail) other.open = false; }); }));
    document.addEventListener('cart:count:update', event => {
      const badge = document.querySelector('.blz-bag span');
      if (badge && Number.isFinite(event.detail?.item_count)) badge.textContent = event.detail.item_count;
    });
    const confirmation = document.querySelector('#blz-added');
    confirmation.querySelectorAll('button').forEach(button => button.addEventListener('click', () => confirmation.close()));
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!form.matches('.blz-card-form')) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      button.disabled = true;
      form.querySelector('[role="alert"]')?.remove();
      try {
        const url = new URL(form.action); url.pathname += '.js';
        const body = new FormData(form);
        const drawer = document.querySelector('hdt-cart-drawer');
        if (drawer) { body.set('sections', drawer.getAttribute('section-id')); body.set('sections_url', location.pathname); }
        const response = await fetch(url, {method:'POST',body,headers:{Accept:'application/json'}});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || confirmation.dataset.addError);
        if (drawer && data.sections?.[drawer.getAttribute('section-id')]) {
          document.dispatchEvent(new CustomEvent('cart:update', {detail:{cartData:data,source:'product-form-component',actionAfterATC:'open_cart_drawer'}}));
          return;
        }
        if (location.pathname === confirmation.dataset.cartUrl) {
          location.assign(confirmation.dataset.cartUrl);
          return;
        }
        const product = confirmation.querySelector('.blz-added-product'); product.replaceChildren();
        if (data.image) { const img=document.createElement('img');img.src=data.image;img.alt='';product.append(img); }
        const title=document.createElement('p');title.textContent=data.product_title || data.title;product.append(title);
        confirmation.showModal();
        fetch(confirmation.dataset.cartUrl+'.js').then(r=>r.json()).then(cart=>{document.querySelector('.blz-bag span').textContent=cart.item_count;}).catch(()=>{});
      } catch (error) { const alert=document.createElement('p');alert.setAttribute('role','alert');alert.textContent=error.message || confirmation.dataset.addError;form.append(alert); }
      finally { button.disabled=false; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blz-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blz-slideshow')) customElements.define('blz-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.blz-slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.toggleButton = this.querySelector('[data-action="toggle"]');
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.action === 'toggle') { this.paused = !this.paused; this.updateToggle(); this.schedule(); }
        else if (button.dataset.slide !== undefined) this.show(Number(button.dataset.slide));
        else if (button.dataset.action === 'prev') this.show(this.index - 1);
        else if (button.dataset.action === 'next') this.show(this.index + 1);
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, options);
      this.addEventListener('touchstart', event => { this.touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {...options,passive:true});
      this.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx=event.changedTouches[0].clientX-this.touchStart.x, dy=event.changedTouches[0].clientY-this.touchStart.y;
        if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) this.show(this.index+(dx<0?1:-1));
        this.touchStart=null;
      }, {...options,passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if(this.motion.matches) this.paused=true; this.updateToggle();this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);
        if(index>=0){this.paused=true;this.show(index);this.updateToggle();}
      }, options);
      this.updateToggle(); this.schedule();
    }
    updateToggle() { if(this.toggleButton){this.toggleButton.textContent=this.paused?'Play':'Pause';this.toggleButton.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');} }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;slide.inert=i!==this.index;});
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
      this.querySelector('.blz-slides').setAttribute('aria-live',this.paused?'polite':'off');
      this.schedule();
    }
    schedule() { clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||6000); }
    disconnectedCallback(){clearTimeout(this.timer);this.events?.abort();this.ready=false;}
  });

  } catch(e) { console.error(e); }
})();
})();
